import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.from";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.replace";
import _typeof from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/typeof";
import env from '@tencent/vft-common/env';
export function parseTemplate(str) {
  var ctx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return (str || '').replace(/\$\{(\w+)\}/g, function (s, $1) {
    return ctx[$1] || '';
  });
}
export function removeHttp(src) {
  if (!src) return src;

  if (_typeof(src) === 'object' && src.backgroundImage) {
    // eslint-disable-next-line no-param-reassign
    src.backgroundImage = src.backgroundImage.replace(/^http(s?):/, '');
    return src;
  }

  return src.replace(/^http(s?):/, '');
}
/**
 * 截取字符串
 * @param {string} str
 * @param {number} len
 * @return {string}
 */

export function cutStrWithEmoji(str, len) {
  if (typeof str !== 'string') {
    return str;
  }

  var length = 0;
  var strArr = Array.from(str); // ES6的Array.from支持代理对的解析

  var strArrlen = strArr.length;
  var result = ''; // eslint-disable-next-line no-plusplus

  for (var i = 0; i < strArrlen; i++) {
    var item = strArr[i];
    length += 1;

    if (escape(item).length > 4) {
      // 中文或表情符编码后长度大于4，按两个字符的宽度计算
      length += 1;
    }

    result = result.concat(item);

    if (length >= len) {
      if (i === strArrlen - 1) {
        return result;
      }

      result = result.concat('...');
      return result;
    }
  }

  return str;
}
export function replaceUrl(href) {
  if (!href) {
    return;
  }

  var _window = window,
      location = _window.location,
      history = _window.history;
  var result = location.protocol + removeHttp(href);

  if (history.replaceState) {
    history.replaceState(null, document.title, result);
    location.replace('');
  } else {
    location.replace(result);
  }
}
export function getDefaultAvatar() {
  return '//thirdqq.qlogo.cn/g?b=sdk&k=4Hfd8rBxU0Nz2cIoFCMQRg&s=100&t=0';
}
export function setTitle(title) {
  if (title === undefined || window.document.title === title) {
    return;
  }

  document.title = title; // if (isIos && !isDesktop) {

  var iframe = document.createElement('iframe');
  iframe.style.display = 'none'; // 替换成站标favicon路径或者任意存在的较小的图片即可

  iframe.setAttribute('src', '/favicon.ico');

  var iframeCallback = function iframeCallback() {
    setTimeout(function () {
      iframe.removeEventListener('load', iframeCallback);
      document.body.removeChild(iframe);
    }, 0);
  };

  iframe.addEventListener('load', iframeCallback);
  document.body.appendChild(iframe); // }
}
export function getPlatform() {
  if (env.isApp) {
    if (env.isIphone) {
      return 5;
    }

    if (env.isIpad) {
      return 4;
    }

    if (env.isAndroid) {
      return 3;
    }

    return 16;
  }

  return 2;
}